import React, { HTMLAttributes } from 'react';
import classNames from 'classnames';

type Props = {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary';
} & HTMLAttributes<HTMLDivElement>;

const Block: React.FC<Props> = ({
  className,
  children,
  variant = 'primary',
  ...rest
}) => {
  return (
    <div
      className={classNames(
        'rounded-2xl p-4',
        {
          'border-primary-block-border border-block-primary-border bg-bg-surface text-text-secondary':
            variant === 'primary',
        },
        {
          'border-secondary-block-border border-block-secondary-border bg-bg-surface-alt text-text-secondary':
            variant === 'secondary',
        },
        className ?? ''
      )}
      {...rest}
    >
      {children}
    </div>
  );
};

export default Block;
